// extracted by mini-css-extract-plugin
export default {"itemTypeWrapper":"ItemTypeCell_itemTypeWrapper__QNNQf"};